import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Play, Pause, Mic, Sparkles } from "lucide-react";

const B = process.env.REACT_APP_BACKEND_URL;

export default function PublicVoiceWall({ stationId, items, accent }) {
  const [playingId, setPlayingId] = useState("");
  const audioRef = useRef(null);

  const toggle = (id) => {
    if (playingId === id) {
      audioRef.current?.pause();
      setPlayingId("");
      return;
    }
    audioRef.current?.pause();
    const a = new Audio(`${B}/api/voice/public/${stationId}/wall/${id}/audio`);
    audioRef.current = a;
    a.onended = () => setPlayingId("");
    a.play().then(() => setPlayingId(id)).catch(() => setPlayingId(""));
  };

  const ago = (iso) => {
    const d = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
    return d <= 0 ? "today" : d === 1 ? "yesterday" : `${d}d ago`;
  };

  return (
    <div className="space-y-3" data-testid="engage-voice-wall">
      <div className="rounded-xl border border-white/10 bg-white/[0.03] p-5">
        <div className="text-sm font-bold flex items-center gap-2"><Mic className="h-4 w-4" style={{ color: accent }} /> Listener voices on air</div>
        <p className="mt-1 text-xs text-white/50">Real messages from listeners like you — tap to listen.</p>
      </div>
      {items.map((it) => (
        <div key={it.submission_id} className="rounded-xl border border-white/10 bg-white/[0.03] p-4 flex items-center gap-3" data-testid={`wall-item-${it.submission_id}`}>
          <button onClick={() => toggle(it.submission_id)} data-testid={`wall-play-${it.submission_id}`}
            className="h-11 w-11 rounded-full flex items-center justify-center text-black shrink-0 transition hover:scale-105"
            style={{ background: accent }}>
            {playingId === it.submission_id ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4 ml-0.5" />}
          </button>
          <div className="min-w-0 flex-1">
            <div className="text-sm font-bold truncate">
              {it.name}{it.location ? <span className="text-white/40 font-normal"> · {it.location}</span> : ""}
              {it.produced && <Sparkles className="inline h-3 w-3 ml-1.5 -mt-0.5" style={{ color: accent }} title="Produced with station intro" />}
            </div>
            <div className="text-[11px] text-white/45">{it.type}{it.duration ? ` · ${it.duration}s` : ""} · {ago(it.created_at)}</div>
          </div>
        </div>
      ))}
      <Link to={`/voice/${stationId}`} data-testid="wall-record-cta"
        className="block rounded-xl border border-dashed border-white/20 p-4 text-center text-sm font-bold hover:border-white/40 transition"
        style={{ color: accent }}>
        <Mic className="inline h-4 w-4 mr-1.5 -mt-0.5" />Record your own message — you might hear yourself on air
      </Link>
    </div>
  );
}
